import Button from '@/src/components/Antd/Button/Button';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import ProductSelection from 'src/constrains/ProductsSelection/ProductsSelection';
import css from './css.less';
// import { setProductSet } from '../redux/productSet';
import { useDispatch, useSelector } from 'react-redux';
import { onOkCompare } from 'src/constrains/ProductsSelection/tools';
// import { EnumModifiedType } from '../type';
import EditableTable, {
  BackTitle,
  EditIcon,
  FirstTitle,
  FrontTitle,
} from '@/src/components/EditableTable/EditableTable';
import {
  TableInput,
  TableNumberInput,
} from 'src/components/EditableTable/TableForm/TableForm';
import ToolTip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import { EnumProductType } from 'src/types/common/product';
import {
  deleteProduct as delProduct,
  getProducts,
  getSuppliers,
  reselectProducts,
  setProducts,
} from '../slice';
import { generateProductSetItem } from './tools';
import { Icon } from '@/src/tools/icon';

const convertQuery = (filter, re) => {
  if (filter.suppliers) {
    if (filter.suppliers.length > 0) {
      re.suppliers = filter.suppliers.map((i) => {
        const { value } = i;
        return { uuid: value };
      });
    }
  }
  // if (filter.productTypes) {
  //   if (filter.productTypes.length > 0) {
  //     re.productTypes = filter.productTypes.map((i) => {
  //       const { value } = i;
  //       return value;
  //     });
  //   }
  // }
  // if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};
const ProductSet = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const suppliers = useSelector(getSuppliers()) || [];
  const { disabled, onBulkImport } = props;
  const [visible, setVisible] = React.useState(false);
  const dispatch = useDispatch();
  const stockProducts = useSelector(getProducts());

  const columns = React.useMemo(() => {
    return [
      {
        title: () => (
          <FirstTitle>
            <span>{getI18n('general.sKU')}</span>
          </FirstTitle>
        ),
        key: 'SKU',
        childGenerate: (text, record, index) => {
          const { product } = record;
          const { sku } = product;
          return (
            <NoWrapContainer>
              <ToolTip title={sku}>{sku}</ToolTip>
            </NoWrapContainer>
          );
        },
        minWidth: 180,
        default: true,
      },
      {
        title: () => (
          <FrontTitle>
            <span>
              {getI18n('stockIn.stock.detail_stockproductselection_Product')}
            </span>
          </FrontTitle>
        ),

        childGenerate: (text, record, index) => {
          const { product } = record;
          const { name } = product;
          return (
            <NoWrapContainer>
              <ToolTip title={name}>{name}</ToolTip>
            </NoWrapContainer>
          );
        },
        key: 'Product',
        minWidth: 176,
        default: true,
      },
      {
        title: () => (
          <FrontTitle>
            <span>
              {getI18n('stockIn.stock.detail_stockproductselection_Remarks')}
            </span>
          </FrontTitle>
        ),

        childGenerate: (text, record, index) => {
          const { product } = record;
          const { remarks } = product;
          return (
            <NoWrapContainer>
              <ToolTip title={remarks}>{remarks}</ToolTip>
            </NoWrapContainer>
          );
        },
        key: 'noOfUnit',
        minWidth: 160,
        default: true,
      },
      {
        title: () =>
          disabled ? (
            getI18n('stockIn.stock.detail_stockproductselection_Stock')
          ) : (
            <BackTitle>
              <EditIcon />
              <span>
                {getI18n('stockIn.stock.detail_stockproductselection_Stock')}
              </span>
            </BackTitle>
          ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { quantity, quantityError } = record;

          return disabled ? (
            <NoWrapContainer>
              <ToolTip title={quantity}>{quantity}</ToolTip>
            </NoWrapContainer>
          ) : (
            <TableNumberInput
              error={quantityError}
              rightPosition
              value={quantity}
              onChange={(e) => {
                productItemOnChange(index, { quantity: e });
              }}
            />
          );
        },
        key: 'Stock',
        align: 'right',
        minWidth: 100,
        default: true,
      },
      {
        title: () =>
          disabled ? (
            getI18n('stockIn.stock.stocklistconfig_columns_Notes_title')
          ) : (
            <FrontTitle>
              <EditIcon />
              <span>
                {getI18n('stockIn.stock.stocklistconfig_columns_Notes_title')}
              </span>
            </FrontTitle>
          ),

        childGenerate: (text, record, index) => {
          const { notes, notesError } = record;
          return disabled ? (
            <NoWrapContainer>
              <ToolTip title={notes}>{notes}</ToolTip>
            </NoWrapContainer>
          ) : (
            <TableInput
              error={notesError}
              rightPosition
              value={notes}
              onChange={(e) => {
                productItemOnChange(index, { notes: e });
              }}
            />
          );
        },
        key: 'Sum',
        align: 'left',
        minWidth: 198,
        default: true,
      },
    ];
  }, [stockProducts]);

  const onCancel = () => {
    setVisible(false);
  };
  const onOpen = () => {
    setVisible(true);
  };
  const onOk = (products) => {
    const r = onOkCompare(products, stockProducts, generateProductSetItem);
    dispatch(
      reselectProducts({
        products: r,
      }),
    );
  };
  const selectedItems = React.useMemo(() => {
    return stockProducts.map((i) => i.product);
  }, [stockProducts]);
  const productItemOnChange = (index, obj) => {
    dispatch(
      setProducts({
        index,
        modifiedItems: obj,
      }),
    );
  };
  const deleteProduct = (index) => {
    dispatch(delProduct(index));
  };

  return (
    <SectionWrapper
      title={getI18n(
        'stockIn.stock.detail_stockproductselection_StockInProducts_title',
      )}
      subtitle={getI18n(
        'stockIn.stock.detail_stockproductselection_StockInProducts_subtitle',
      )}
      rightPart={
        disabled ? null : (
          <Button
            type='link'
            icon={<Icon type='iconimport' />}
            className={css.importBtn}
            onClick={onBulkImport}>
            {getI18n('general.import')}
          </Button>
        )
      }>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={onCancel}
          onOk={onOk}
          queryActiveProducts={false}
          selectedItems={selectedItems}
          hideAllDefaultTypeFilters
          fixedSearchConditions={{ productTypes: [EnumProductType.Simple] }}
          extraFilters={[
            {
              type: EnumFilterType.MultipleSelection,
              searchable: true,
              options: suppliers.map((i) => {
                const { name, uuid } = i;
                return { label: name, value: uuid };
              }),
              keyWord: 'suppliers',
              dropdownProps: {
                name: getI18n(
                  'stockIn.stock.stocklistconfig_columns_supplier_title',
                ),
              },
            },
            {
              type: EnumFilterType.MultipleSelection,
              searchable: true,
              options: [],
              keyWord: 'staff',
              dropdownProps: {
                name: getI18n(
                  'stockIn.stock.stocklistconfig_columns_byStaff_title',
                ),
              },
            },
          ]}
          customFilterTransfer={convertQuery}
        />
      )}

      {!disabled && (
        <div className={css.buttonContainer}>
          <Button type='primary' className={css.selectionBtn} onClick={onOpen}>
            {getI18n('stockIn.stock.selectProducts')}
          </Button>
        </div>
      )}

      {(stockProducts || []).length > 0 && (
        <EditableTable
          rowKey={'uuid'}
          data={stockProducts}
          columns={columns}
          id='StockProductSelection'
          {...(disabled ? {} : { rowDeleteFunc: deleteProduct })}
        />
      )}
    </SectionWrapper>
  );
};
export default ProductSet;
